<div class="container h-100">
    <dynamic-list #list class="h-100"
          [canLoadMoreTop]="false"
          [canLoadMoreBottom]="false"
          [initialBottomItems]="(listItems$ | async)!"
    >
    </dynamic-list>
</div>
